import React , {Component} from 'react';
import * as axios from "axios/index";
import * as vars from './../Vars';

class OrderAddressCard extends Component{

    render(){
        const {object , selectedAddress} = this.props
        return(
            <div>
                <div className={"card-custom-7 " + (selectedAddress === object.id ? "selected " : "") + (object.available === false ? "unavailable " : "")} onClick={() => this.props.selectedAddressChange(object.id)}>
                    <div className="item">
                        <div className="row no-gutters justify-content-between">
                            <div className="col-auto">
                                <div className="title">
                                    {object.title}

                                    {
                                        object.available === false ?
                                        (
                                            <span className="unavailable mr-3">
                                                خارج از محدوده
                                            </span>
                                        )
                                        :
                                        (``)
                                    }
                                </div>
                            </div>
                            <div className="col-auto">
                                {/*edit*/}
                            </div>
                        </div>
                        <div className="row no-gutters mt-2">
                            <div className="col">
                                <div className="body">
                                    {object.body}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default OrderAddressCard;